
import { takeEvery, put, call, takeLatest } from "redux-saga/effects";

import {
    GET_POLICIES,
    GET_POLICIES_SUCCESS,
    GET_POLICIES_API_ERROR,

    GET_POLICIE,
    GET_POLICIE_SUCCESS,
    GET_POLICIE_API_ERROR
} from "./actionTypes";

import {
  getPoliciesSuccess,
  apigetPolicieError,
  getPolicieSuccess
} from "./actions";


import {
    getPolicieAPI,getPoliciesAPI
} from "../../api/policies_api"


function* getPolicies({ payload: params  }) {
    try {

        const response = yield call(getPoliciesAPI, params)
        yield put(getPoliciesSuccess(response))

    } catch (error) {
        yield put(apigetPolicieError(error))
    }
}

function* getPolicie({ payload: params  }) {
    try {

        const response = yield call(getPolicieAPI, params)
        yield put(getPolicieSuccess(response))

    } catch (error) {
        yield put(apigetPolicieError(error))
    }
}

function* PolicieSaga() {
    yield takeEvery(GET_POLICIE, getPolicie),
    yield takeEvery(GET_POLICIES, getPolicies)
}

export default PolicieSaga